import { render, staticRenderFns } from "./courseChoose.vue?vue&type=template&id=83dcf7ea&scoped=true"
import script from "./courseChoose.vue?vue&type=script&lang=js"
export * from "./courseChoose.vue?vue&type=script&lang=js"
import style0 from "./courseChoose.vue?vue&type=style&index=0&id=83dcf7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dcf7ea",
  null
  
)

export default component.exports